var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralIconsDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5-3H19V-6.378a1.5,1.5,0,0,0-.441-1.059l-3.122-3.122A1.5,1.5,0,0,0,14.378-11H13v-1.5A1.5,1.5,0,0,0,11.5-14h-8A1.5,1.5,0,0,0,2-12.5V-11H.25a.251.251,0,0,0-.25.25v.5A.251.251,0,0,0,.25-10h8.5A.251.251,0,0,1,9-9.75v.5A.251.251,0,0,1,8.75-9H1.25A.251.251,0,0,0,1-8.75v.5A.251.251,0,0,0,1.25-8h6.5A.251.251,0,0,1,8-7.75v.5A.251.251,0,0,1,7.75-7H.25A.251.251,0,0,0,0-6.75v.5A.251.251,0,0,0,.25-6h6.5A.251.251,0,0,1,7-5.75v.5A.251.251,0,0,1,6.75-5H2v4A3,3,0,0,0,5,2,3,3,0,0,0,8-1h4a3,3,0,0,0,3,3,3,3,0,0,0,3-3h1.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,19.5-3ZM5,.5A1.5,1.5,0,0,1,3.5-1,1.5,1.5,0,0,1,5-2.5,1.5,1.5,0,0,1,6.5-1,1.5,1.5,0,0,1,5,.5Zm10,0A1.5,1.5,0,0,1,13.5-1,1.5,1.5,0,0,1,15-2.5,1.5,1.5,0,0,1,16.5-1,1.5,1.5,0,0,1,15,.5ZM17.5-6H13V-9.5h1.378L17.5-6.378Z",
    transform: "translate(0 14)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsDelivery);
export default __webpack_public_path__ + "static/media/generalIcons_Delivery.c5bb815d.svg";
export { ForwardRef as ReactComponent };